import { QueryKeyConfig, MutationKeyConfig } from './api-helper';

export interface ApprovalListRequestArgs {
    leaveStatusID?: number;
    requestedBy?: string;
    fromDate?: string;
    toDate?: string;
}

const getApprovalQueryStrings = (args: ApprovalListRequestArgs) => {
    const { leaveStatusID, requestedBy, fromDate, toDate } = args;
    let queryString = "";

    if (leaveStatusID) {
        queryString += `${queryString ? '&' : ''}LeaveStatusID=${leaveStatusID}`;
    }
    if (requestedBy) {
        queryString += `${queryString ? '&' : ''}RequestedBy=${requestedBy}`;
    }
    if (fromDate) {
        queryString += `${queryString ? '&' : ''}FromDate=${fromDate}`;
    }
    if (toDate) {
        queryString += `${queryString ? '&' : ''}ToDate=${toDate}`;
    }
    return queryString;
};

export const leaveManageApiKeyStore = {
    applyLeave: (): MutationKeyConfig => ({
        mutationKey: [`APPLY_LEAVE`],
        route: `/Leave`,
        action: 'POST',
    }),
    getLeaves: (): QueryKeyConfig => ({
        queryKey: [`GET_LEAVES`],
        route: `/Leave`,
    }),
    getLeaveApprovalList: (args: ApprovalListRequestArgs): QueryKeyConfig => ({
        queryKey: [`GET_LEAVE_APPROVAL_LIST`,
            [
                args.leaveStatusID,
                args.requestedBy,
                args.fromDate,
                args.toDate].filter((a) => a),],
        route: `/Leave/GetLeaveApprovalList?${getApprovalQueryStrings(args)}`,
    }),
    getLeaveRequestCount: (): QueryKeyConfig => ({
        queryKey: [`GET_LEAVE_REQUEST_COUNT`],
        route: `/Leave/GetLeaveRequestCounts`,
    }),
    getLeaveTypes: (): QueryKeyConfig => ({
        queryKey: [`GET_LEAVE_TYPES`],
        route: `/Leave/GetLeaveRequestTypes`,
    }),
    getLeaveStatus: (): QueryKeyConfig => ({
        queryKey: [`GET_LEAVE_STATUS`],
        route: `/Leave/GetLeaveRequestStatus`,
    }),
    processLevelRequest: (): MutationKeyConfig => ({
        mutationKey: [`PROCESS_LEVEL_REQUEST`],
        route: `/Leave/ProcessLeaveRequest`,
        action: 'POST',
    }),
};
